var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.833,
    height: 27.592,
    viewBox: "0 0 24.833 27.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Broken_Document",
    "data-name": "Iconly/Broken/Document",
    transform: "translate(-4.139 -2.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(4.139 2.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Document-2",
    "data-name": "Document",
    d: "M13.8,27.592a1.013,1.013,0,0,1,0-2.01h3.929c3.387,0,5.093-1.742,5.093-5.176V7.188c0-3.436-1.706-5.178-5.093-5.178H7.089C3.7,2.01,1.983,3.752,1.983,7.188V20.405c0,3.434,1.717,5.176,5.106,5.176a1.013,1.013,0,0,1,0,2.01C2.655,27.592,0,24.9,0,20.405V7.188C0,2.68,2.655,0,7.089,0H17.733c4.433,0,7.087,2.692,7.1,7.188V20.405c0,4.495-2.643,7.187-7.089,7.187ZM7.436,20.636H7.425a1,1,0,0,1,0-2h9.947a1,1,0,0,1,0,2ZM17.372,14.8H7.425a1.013,1.013,0,0,1,0-2.01h9.947a.993.993,0,0,1,.955.467,1.028,1.028,0,0,1,0,1.075,1,1,0,0,1-.846.474A.983.983,0,0,1,17.372,14.8ZM7.436,8.966a1.013,1.013,0,0,1,0-2.01h3.785a1.013,1.013,0,0,1,0,2.01Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.841549a29cf67e70030d09e25cd7878c.svg";
export { ForwardRef as ReactComponent };